/**
 * Created by luka on 23.02.2018.
 */
import {post} from "../utils/api";
import {
    navigationBack, navigationToRating, navigationToSuccess,
    navigationToSurvey
} from "../navigation/NavigationActions";
import {CONFIRMED, CURRENT_CONFIRMED} from "../overview/DayStates";
import {
    LOADING_SUBMIT_FAILED, SUBMIT_ALREADY_MISSED,
    SUBMIT_LOADING
} from "../actions/types";
import {DAY_SUBMITTED} from "../utils/constants";
import {workoutFetchDataSuccess} from "./WorkoutAction";
import {getHideShare, hasSurveyCount} from "../utils/settingsStore";
import {clearWorkout} from "../utils/workoutStore";

export function loadingSubmitFailed(error) {
    return {
        type: LOADING_SUBMIT_FAILED,
        error
    };
}

export function submitAlreadyMissed() {
    return {
        type: SUBMIT_ALREADY_MISSED,
    };
}

export function submitLoading(bool) {
    return {
        type: SUBMIT_LOADING,
        isLoading: bool
    };
}

export function submitFetchData(dayId, exercises, userOnTrack) {
    //console.log(exercises);
    return (dispatch) => {
        dispatch(submitLoading(true));

        post('submitday', {
            _id: dayId,
            exercises: exercises
        })
            .then((submitResponse) => {
                if (isSubmitStateSuccessful(submitResponse)) {
                    console.log('submit good');
                    clearWorkout();
                    dispatch(workoutFetchDataSuccess({}));
                    console.log(getHideShare());
                    /*if(!hasSurveyCount()) {
                     dispatch(navigationToSurvey());
                     }else{
                     dispatch(navigationBack());
                     }*/
                    //  if ()
                     dispatch(navigationToRating(submitResponse.day.position));
                    // if (submitResponse.day.position === 2) {
                    //     dispatch(navigationToRating());
                    //     dispatch(navigationToSuccess());
                    // } else if(submitResponse.day.position === 30 && userOnTrack === true){
                    // } else {
                    // }
                } else {
                    console.log(submitResponse.msg + ' submit not good');
                    dispatch(submitAlreadyMissed());
                    dispatch(workoutFetchDataSuccess({}));
                }

                dispatch(submitLoading(false));
            })
            .catch((error) => {
                dispatch(loadingSubmitFailed(error));
                dispatch(submitLoading(false));
            });
    };
}

function isSubmitStateSuccessful(submitResponse) {
    if (submitResponse.msg === DAY_SUBMITTED) {
        return true;
    }
    return submitResponse.state === CURRENT_CONFIRMED || submitResponse.state === CONFIRMED;

}



// WEBPACK FOOTER //
// ./src/workout/SubmitAction.js